import React from "react";
import aosbLogo from "../assets/images/aosb_ces_logo.jpg";

interface FirmItem {
  title: string;
  imageSrc: string;
  redirectUrl: string;
  imageAlt: string;
}

const firmList: FirmItem[] = [
  {
    title: "ASO 2. VE 3. OSB",
    imageSrc: "/images/firma/asobcev.png",
    redirectUrl: "https://www.asobcev.com.tr/",
    imageAlt: "ASO 2-3 OSB Logo"
  },
  {
    title: "ADANA HACI SABANCI OSB",
    imageSrc: aosbLogo,
    redirectUrl: "http://www.aosb-co2.com/",
    imageAlt: "ADANA OSB"
  },
  {
    title: "TOBB MEYBEM",
    imageSrc: "/images/firma/meybem-logo.svg",
    redirectUrl: "https://meybem.org.tr/kurumsal-karbon-ayak-izi-egitimi-ankara/",
    imageAlt: "TOBB MEYBEM"
  },
  {
    title: "Cimpact Pro",
    imageSrc: "https://cimpactpro.com/view/default/assets/img/h50.png",
    redirectUrl: "https://cimpactpro.com/ozel-cozumler/osb",
    imageAlt: "Cimpact Pro"
  },
  {
    title: "GREENJOBS BİLGİ TEKNOLOJİLERİ",
    imageSrc: "/images/firma/greenjobs.png",
    redirectUrl: "https://www.greenjobs.com.tr",
    imageAlt: "GREENJOBS"
  },
  {
    title: "ABM YÖNETİM DANIŞMANLIK A.Ş.",
    imageSrc: "/images/firma/abs.png",
    redirectUrl: "https://abmdanismanlik.com.tr",
    imageAlt: "ABM Danışmanlık"
  }
];

const ProtokolFirmalarComponent = () => {
  return (
    <div className="card my-4 p-3 md:p-5">
      <div className="text-center mb-4">
        <h3 className="text-900 text-2xl md:text-3xl font-bold mb-2">Protokol Yapılan Firmalar</h3>
        <p className="text-600 text-sm md:text-base m-0">İş birliği içinde olduğumuz kuruluş ve kurumlar</p>
      </div>
      <div className="grid justify-content-center align-items-stretch">
        {firmList.map((firm, index) => (
          <div key={index} className="col-12 sm:col-6 md:col-4 lg:col-2 p-2">
            <div
              className="surface-card border-1 surface-border border-round-xl p-3 h-full flex flex-column align-items-center justify-content-between cursor-pointer hover:shadow-3 transition-all transition-duration-200"
              style={{ minHeight: "150px" }}
              onClick={() => window.open(firm.redirectUrl, "_blank", "noopener,noreferrer")}
              role="button"
              tabIndex={0}
            >
              <div className="flex-1 flex align-items-center justify-content-center w-full my-2">
                <img
                  src={firm.imageSrc}
                  alt={firm.imageAlt}
                  style={{
                    maxHeight: "56px",
                    maxWidth: "100%",
                    objectFit: "contain"
                  }}
                  loading="lazy"
                />
              </div>
              <span className="font-semibold text-xs text-center text-700 mt-2 line-clamp-2">
                {firm.title}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProtokolFirmalarComponent;
